// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VHPJq","tabsBox":"styles_tabsBox__2-itJ","createButton":"styles_createButton__dGDqI"};